export const ALLOWED_PHONE_COUNTRIES = new Set<string>([
    // Europe
    'AX', // Åland Islands (+358)
    'AL', // Albania (+355)
    'AD', // Andorra (+376)
    'AT', // Austria (+43)
    'BE', // Belgium (+32)
    'BA', // Bosnia and Herzegovina (+387)
    'BG', // Bulgaria (+359)
    'HR', // Croatia (+385)
    'CZ', // Czech Republic (+420)
    'DK', // Denmark (+45)
    'EE', // Estonia (+372)
    'FO', // Faroe Islands (+298)
    'FI', // Finland (+358)
    'FR', // France (+33)
    'DE', // Germany (+49)
    'GI', // Gibraltar (+350)
    'GR', // Greece (+30)
    'GG', // Guernsey (+44)
    'HU', // Hungary (+36)
    'IS', // Iceland (+354)
    'IE', // Ireland (+353)
    'IM', // Isle of Man (+44)
    'IT', // Italy (+39)    +393471234567 example
    'JE', // Jersey (+44)
    'XK', // Kosovo (+383)
    'LV', // Latvia (+371)
    'LI', // Liechtenstein (+423)
    'LT', // Lithuania (+370)
    'LU', // Luxembourg (+352)
    'MK', // North Macedonia (+389)
    'MT', // Malta (+356)
    'MD', // Moldova (+373)
    'MC', // Monaco (+377)
    'ME', // Montenegro (+382)
    'NL', // Netherlands (+31)
    'NO', // Norway (+47)
    'PL', // Poland (+48)
    'PT', // Portugal (+351)
    'RO', // Romania (+40)
    'SM', // San Marino (+378)
    'RS', // Serbia (+381)
    'SK', // Slovakia (+421)
    'SI', // Slovenia (+386)
    'ES', // Spain (+34)
    'SJ', // Svalbard and Jan Mayen (+47)
    'SE', // Sweden (+46)
    'CH', // Switzerland (+41)
    'UA', // Ukraine (+380)
    'GB', // United Kingdom (+44)
    'VA', // Vatican City (+379 / +39)

    // Latin America
    'BR', // Brazil (+55)
]);
